import { UtmKey } from '@synapex/tools/utils'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { UTM_KEY } from '../invite-links-group/invite-links-group.query.constants'
import { siteLinksService, UtmReply } from './site-links.service'

export function useGetUTM(
    key: UtmKey,
    siteId: number,
    options?: UseQueryOptions<UtmReply[], Error>
) {
    return useQuery<UtmReply[], Error>({
        queryKey: [UTM_KEY[key].query, siteId],
        queryFn: () => siteLinksService.getUTM(key, siteId),
        staleTime: 1000 * 60 * 5,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        ...options,
    })
}
